"use strict";

export default () => {
  return input => {
    return input ? "Ja" : "";
  };
};
